import { render, staticRenderFns } from "./TerminalFile.vue?vue&type=template&id=2bee3fbf&scoped=true&"
import script from "./TerminalFile.vue?vue&type=script&lang=js&"
export * from "./TerminalFile.vue?vue&type=script&lang=js&"
import style0 from "./TerminalFile.vue?vue&type=style&index=0&id=2bee3fbf&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bee3fbf",
  null
  
)

export default component.exports